import { Link } from 'react-router-dom';
import './auth.scss';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import clsx from 'clsx';
import { authenticationHttpService } from '@myinnsworth/httpServices';
import { useState } from 'react';

const forgotPasswordSchema = yup.object({
    email: yup.string().email('Invalid email address').required('Invalid email address'),
  }).required();

interface IForgotPasswordSchema {
    email: string;
}

enum PasswordResetState {
    None,
    Success
}

export default function ForgotPassword() {
    const [resetState, setResetState] = useState<PasswordResetState>(PasswordResetState.None);
    const {register: registerInput, handleSubmit, clearErrors, formState: {errors} } = useForm<IForgotPasswordSchema>({
        resolver: yupResolver(forgotPasswordSchema)
    });

    const onSubmit = async (formData: IForgotPasswordSchema) => {
        clearErrors();
        
        await authenticationHttpService.beginPasswordReset(formData);
        setResetState(PasswordResetState.Success);
    };

    return (<>
        {resetState === PasswordResetState.None && (
            <>
            <h6>Log in to My.Innsworth</h6>
            <div className="spacing-l"></div>

            <form className="auth-form-container" noValidate onSubmit={handleSubmit(onSubmit)}>
                <div className={clsx('form-control', 'normal', { 'error': errors.email })}>
                    <label >Email address</label>
                    <input {...registerInput('email')}
                        type="email"
                        className={clsx('icon-person', { 'error': errors.email })}
                        placeholder='Email Address' />
                    {errors.email && <p>{errors.email.message}</p>}
                    {!errors.email && <p>Please enter your email address</p>}
                </div>

                <div className="spacing-m"></div>

                <div className="flex justify-center">
                    <button type="submit" className="btn primary medium">Send reset</button>
                </div>

                <div className="spacing-m"></div>

                <div className="flex direction-column align-center">
                    <Link className='link secondary' to={"/auth/sign-in"} >Back to login</Link>
                </div>

            </form>
        </>
        )}

        {resetState === PasswordResetState.Success && (<>
            <h6 className='text-center'>Notification with confirmation link has been sent to your email</h6>
            <div className="spacing-l"></div>

            <div className="flex direction-column align-center">
                <Link className='btn primary large back' to={"/auth/sign-in"} >Back</Link>
            </div>
        </>)}
    </>)
}